import ROUTE from '@us/app/router/appModule/names'
import env from '@shared/env.js'

export default [
  ...(env.isProd
    ? []
    : [
        {
          path: '/uhchub/init',
          name: ROUTE.INIT_UHCHUB,
          component: () => import('@us/app/views/InitUhchub.vue'),
        },
        {
          path: '/webmd-one/init',
          name: ROUTE.INIT_WEBMD_ONE,
          component: () => import('@us/app/views/InitWebMDOne.vue'),
        },
        {
          path: '/personifyhealth/init',
          name: ROUTE.INIT_PERSONIFY_HEALTH,
          component: () => import('@us/app/views/InitPersonifyHealth.vue'),
        },
      ]),
  {
    path: '/sword',
    name: ROUTE.SWORD_REDIRECT,
    component: () => import('@us/app/views/SwordRedirect.vue'),
    meta: {
      name: 'sword_redirect',
    },
  },
  {
    path: '/password-reset',
    name: ROUTE.PASSWORD_RESET,
    component: () => import('@shared/views/PasswordReset.vue'),
  },
  {
    path: '/deeplink-fallback',
    name: ROUTE.DEEPLINK_FALLBACK,
    component: () => import('@shared/views/DeeplinkFallback.vue'),
  },
  {
    path: '/b2b/:pathMatch(.*)*',
    redirect: (to) => {
      return {
        path: to.path.replace(/^\/b2b/, ''),
        query: to.query,
      }
    },
  },
  {
    path: '/partners',
    name: ROUTE.PARTNER_SEARCH,
    component: () => import('@us/app/views/PartnerSearch.vue'),
    meta: {
      name: 'onb_employer_search',
    },
  },
  {
    path: '/:slug?',
    redirect: (to) => {
      const slug = (to.params.slug || to.query.corporate || '').toLowerCase()

      if (!slug) {
        return {
          name: ROUTE.PARTNER_SEARCH,
          query: to.query,
        }
      }

      return {
        name: ROUTE.LANDING_PAGE,
        query: to.query,
        params: {
          slug,
        },
      }
    },
  },
  {
    path: '/:slug/select-verification-method',
    name: ROUTE.SELECT_VERIFICATION_METHOD,
    component: () => import('@us/app/views/Loader.vue'),
  },
  {
    path: '/:slug/information',
    name: ROUTE.LANDING_PAGE,
    component: () =>
      env.isCopd
        ? import('@us/app/views/LandingPageCOPD.vue')
        : import('@us/app/views/LandingPageMSK.vue'),
    meta: {
      name: 'corporate_landing_page',
    },
  },
  {
    path: '/:slug/voucher/:voucherCode?',
    name: ROUTE.VERIFY_WITH_VOUCHER,
    component: () => import('@us/app/views/VerifyWithVoucher.vue'),
    meta: {
      name: 'onb_voucher_verification',
    },
  },
  {
    path: '/:slug/eligibility-list',
    name: ROUTE.VERIFY_WITH_ELIGIBILITY_LIST,
    component: () => import('@us/app/views/VerifyWithEligibilityList.vue'),
    meta: {
      name: 'onb_eligibility_verification',
    },
  },
  {
    path: '/:slug/solera-verification',
    name: ROUTE.VERIFY_WITH_SOLERA,
    component: () => import('@us/app/views/VerifyWithSolera.vue'),
    meta: {
      name: 'onb_eligibility_verification',
    },
  },
  {
    path: '/:slug/uhchub-verification',
    name: ROUTE.VERIFY_WITH_UHCHUB,
    component: () => import('@us/app/views/VerifyWithEligibleToken.vue'),
    meta: {
      name: 'onb_eligibility_verification',
    },
  },
  {
    path: '/:slug/uhcstore-verification',
    name: ROUTE.VERIFY_WITH_UHCSTORE,
    component: () => import('@us/app/views/VerifyWithEligibleToken.vue'),
    meta: {
      name: 'onb_eligibility_verification',
    },
  },
  {
    path: '/:slug/webmd-one-verification',
    name: ROUTE.VERIFY_WITH_WEBMD_ONE,
    component: () => import('@us/app/views/VerifyWithEligibleToken.vue'),
    meta: {
      name: 'onb_eligibility_verification',
    },
  },
  {
    path: '/:slug/sign-up',
    name: ROUTE.SIGN_UP,
    component: () => import('@us/app/views/SignUp.vue'),
    meta: {
      name: 'onb_account_creation',
    },
  },
  {
    path: '/:slug/login',
    name: ROUTE.LOGIN,
    component: () => import('@us/app/views/Login.vue'),
    meta: {
      name: 'onb_signin',
    },
  },
  {
    path: '/:slug/subscription',
    name: ROUTE.SUBSCRIPTION,
    component: () => import('@us/app/views/Subscription.vue'),
    meta: {
      name: 'onb_subscription',
    },
  },
  {
    path: '/:slug/download-link',
    name: ROUTE.DOWNLOAD_LINK,
    component: () => import('@us/app/views/DownloadLink.vue'),
    meta: {
      name: 'onb_download_prompt',
    },
  },
  {
    path: '/:slug/sso-initiated',
    name: ROUTE.SAML_SSO_INITIATED,
    component: () => import('@us/app/views/SamlSSOInitiated.vue'),
  },
  {
    path: '/:slug/sso',
    redirect: { name: ROUTE.SAML_SSO_COMPLETED },
  },
  {
    path: '/:slug/sso-completed',
    name: ROUTE.SAML_SSO_COMPLETED,
    component: () => import('@us/app/views/SamlSSOCompleted.vue'),
  },
  {
    path: '/:slug/sso-error',
    name: ROUTE.SAML_SSO_ERROR,
    component: () => import('@us/app/views/SamlSSOError.vue'),
  },
]
